export enum Links {
  LOANS = '/account/loans',
  SAVINGS = '/account/savings',
  NEW_LOAN = '/account/loans/add',
  NEW_SAVING = '/account/savings/add',
  MANAGE_WALLET = '/account/wallets/manage',
}
